// Flying Star (飛星) meanings based on Luo Shu magic square
export const FLYING_STAR_MEANINGS = {
    1: {
        chinese: '一白',
        english: 'One White',
        element: 'Water',
        elementColor: 'blue',
        nature: 'auspicious',
        meaning: 'Career advancement, intelligence, scholarly success. Favorable for planning, studying, and starting new ventures.',
        keywords: ['Career', 'Wisdom', 'Travel']
    },
    2: {
        chinese: '二黑',
        english: 'Two Black',
        element: 'Earth',
        elementColor: 'amber',
        nature: 'inauspicious',
        meaning: 'Illness and obstacles. Exercise caution with health matters. Avoid major decisions or risky activities.',
        keywords: ['Illness', 'Obstacles', 'Caution']
    },
    3: {
        chinese: '三碧',
        english: 'Three Jade',
        element: 'Wood',
        elementColor: 'green',
        nature: 'inauspicious',
        meaning: 'Arguments, disputes, and legal issues. Avoid confrontations. Not ideal for negotiations or signing contracts.',
        keywords: ['Conflict', 'Arguments', 'Legal']
    },
    4: {
        chinese: '四綠',
        english: 'Four Green',
        element: 'Wood',
        elementColor: 'green',
        nature: 'auspicious',
        meaning: 'Romance, academic success, and creativity. Favorable for study, writing, artistic pursuits, and relationships.',
        keywords: ['Romance', 'Academic', 'Creativity']
    },
    5: {
        chinese: '五黃',
        english: 'Five Yellow',
        element: 'Earth',
        elementColor: 'amber',
        nature: 'inauspicious',
        meaning: 'Misfortune and severe obstacles. The most unfavorable star. Avoid important activities, travel, and major decisions.',
        keywords: ['Misfortune', 'Danger', 'Avoid']
    },
    6: {
        chinese: '六白',
        english: 'Six White',
        element: 'Metal',
        elementColor: 'slate',
        nature: 'auspicious',
        meaning: 'Authority, power, and unexpected windfalls. Favorable for leadership decisions, career moves, and financial opportunities.',
        keywords: ['Authority', 'Power', 'Windfall']
    },
    7: {
        chinese: '七赤',
        english: 'Seven Red',
        element: 'Metal',
        elementColor: 'slate',
        nature: 'inauspicious',
        meaning: 'Competition, robbery, and gossip. Guard against theft and deception. Be cautious with finances and trust.',
        keywords: ['Robbery', 'Competition', 'Gossip']
    },
    8: {
        chinese: '八白',
        english: 'Eight White',
        element: 'Earth',
        elementColor: 'amber',
        nature: 'auspicious',
        meaning: 'Wealth, prosperity, and good fortune. The most auspicious star. Excellent for financial activities, investments, and business.',
        keywords: ['Wealth', 'Prosperity', 'Fortune']
    },
    9: {
        chinese: '九紫',
        english: 'Nine Purple',
        element: 'Fire',
        elementColor: 'red',
        nature: 'auspicious',
        meaning: 'Celebration, future prosperity, and joyful events. Favorable for weddings, partnerships, promotions, and happy occasions.',
        keywords: ['Celebration', 'Joy', 'Promotion']
    }
};

// Get combined flying star interpretation
export const getFlyingStarInterpretation = (first, second) => {
    const star1 = FLYING_STAR_MEANINGS[first];
    const star2 = FLYING_STAR_MEANINGS[second];
    if (!star1 || !star2) return null;
    
    const bothAuspicious = star1.nature === 'auspicious' && star2.nature === 'auspicious';
    const bothInauspicious = star1.nature === 'inauspicious' && star2.nature === 'inauspicious';
    const isDuplicate = first === second;
    
    let overall, overallColor;
    if (bothAuspicious) {
        overall = isDuplicate ? 'Very Auspicious - Double blessing' : 'Auspicious - Positive combination';
        overallColor = 'text-emerald-700 dark:text-emerald-300';
    } else if (bothInauspicious) {
        overall = isDuplicate ? 'Very Challenging - Use extreme caution' : 'Challenging - Proceed carefully';
        overallColor = 'text-red-700 dark:text-red-300';
    } else {
        overall = 'Mixed Energy - Balance opportunities with caution';
        overallColor = 'text-amber-700 dark:text-amber-300';
    }
    
    return { star1, star2, overall, overallColor, isDuplicate };
};
